import { Button, Modal} from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <Modal show centered data-bs-theme="dark">
                <Modal.Header>
                    <Modal.Title className="text-light">Ουπς! Η σελίδα δε βρέθηκε</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-light text-center"> Είτε βρεθήκατε εδώ από λάθος, είτε υπάρχει κάποιο σφάλμα στην εφαρμογή που σας οδήγησε εδώ.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="" onClick={()=>{navigate("/") }}>Επιστρέψτε στην Αρχική Σελίδα</Button>
                </Modal.Footer>
        </Modal>
    );
}

export default NotFoundPage;